import { useState } from 'react'
import { useSelector } from 'react-redux'
import { format } from 'date-fns'
import useFetchBlob from '@/hooks/useFetchBlob'
import { downloadFile } from '@/utils/downloadFile'
import { selectActiveBuildingId } from '@/features/building/buildingSlice'

export default function useUrvExport() {
  const [openExportModal, setOpenExportModal] = useState(false)
  const [startDate, setStartDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  )
  const [endDate, setEndDate] = useState(new Date())
  const [isExporting, setIsExporting] = useState(false)
  const buildingId = useSelector(selectActiveBuildingId)
  const { refetch: exportUrvData } = useFetchBlob(
    '/api/v2/time_tracking/urv/export',
    {
      skip: true,
      params: {
        building_id: buildingId,
        from: format(startDate, 'yyyy-MM-dd'),
        to: format(endDate, 'yyyy-MM-dd')
      },
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    }
  )

  const handleExport = async () => {
    if (isExporting) return

    try {
      setIsExporting(true)

      const { blob, error } = await exportUrvData()

      if (error) {
        throw error
      }

      if (!blob || !blob.size) {
        throw new Error('Empty file received')
      }

      downloadFile(
        blob,
        `urv_report_${format(startDate, 'yyyy-MM-dd')}_${format(
          endDate,
          'yyyy-MM-dd'
        )}.xlsx`,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      )

      setOpenExportModal(false)
    } catch (err) {
      const error = /** @type {any} */ (err)
      console.error(error);
      alert(
        `Ошибка при экспорте: ${
          error.message || error.data?.message || error.error || 'Неизвестная ошибка'
        }`
      )
    } finally {
      setIsExporting(false)
    }
  }

  return {
    openExportModal,
    setOpenExportModal,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    isExporting,
    handleExport
  }
}
